var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-form__text-input",class:[_vm.classes]},[_vm._t("default"),_vm._v(" "),(_vm.enableCounter)?_c('span',{staticClass:"kd-count"},[_vm._v(_vm._s(_vm.inputLength)+" / "+_vm._s(_vm.counterLength))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }